import { hasRoomInviteFields, roomInviteHomePath, ROOM_INVITE_REGISTRY } from "./RoomInvite";

export function roomInviteAuthReturnPath(backTo, registry = ROOM_INVITE_REGISTRY) {
  if (typeof backTo !== "string" || !backTo.startsWith("/home?")) return null;
  try {
    const url = new URL(backTo, "https://room-invite.invalid");
    if (url.origin !== "https://room-invite.invalid" || url.pathname !== "/home" || url.href.includes("#")) return null;
    return roomInviteHomePath(url.search, registry, true);
  } catch (_) { return null; }
}

export function roomInviteRegistrationAgentRid(backTo, storedAgentRid, registry = ROOM_INVITE_REGISTRY) {
  const home = roomInviteAuthReturnPath(backTo, registry);
  if (home) return new URLSearchParams(home.split("?")[1]).get("aid") || "";
  // A malformed invitation must not inherit an unrelated cached commission parent.
  if (typeof backTo === "string") {
    try {
      if (hasRoomInviteFields(new URL(backTo, "https://room-invite.invalid").search, registry)) return "";
    } catch (_) { /* Ordinary return targets keep their existing attribution. */ }
  }
  return storedAgentRid || "";
}
